import { initialPagination } from '@app/constants/pagination';

const tableDataInit = {
  data: [],
  pagination: initialPagination,
  filterOptions: {
    organizationalEntities: [],
    employees: [],
    waterbodies: [],
    type: [],
    status: [],
  },
  loading: false,
  error: false,
};

export { tableDataInit };
